import styled from 'styled-components';

import { theme } from '@notino/react-styleguide-v20';

import { Bold, defaultFontSizeCSS } from '@styles/generalStyles';

export interface IAdditionalProductLabel {
  clickable: boolean;
  disabled: boolean;
}

export const StyledAdditionalProductLabelLink = styled(Bold)<IAdditionalProductLabel>`
  margin: 0.25rem 0 0 0;
  color: ${({ disabled }) => (disabled ? theme.color.text.negative : theme.color.text.primary)};
  ${defaultFontSizeCSS};
  text-decoration: ${({ clickable }) => (clickable ? 'underline' : 'none')};
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'auto')};

  &:hover {
    text-decoration: none;
  }
`;

export const StyledWithDedication = styled.div`
  font-weight: initial;
`;

export const StyledDedication = styled.span`
  color: ${theme.color.text.tertiary};
`;
